import { Link } from "react-router-dom";
import NewsletterForm from "@/components/NewsletterForm";

export default function Footer() {
  return (
    <footer className="bg-ink text-white mt-32" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <span className="inline-flex w-10 h-10 items-center justify-center rounded-full bg-gold text-ink font-display font-semibold">W</span>
            <span className="font-display text-2xl">WinWorld <span className="text-gold">Innovation</span></span>
          </div>
          <p className="text-white/70 text-base leading-relaxed max-w-md">
            A global platform for inventions, AI, media, culture, healing technologies,
            ecological ideas, and peaceful collaboration between humans and AI.
          </p>
          <div className="mt-8">
            <p className="overline mb-3">Join the Newsletter</p>
            <NewsletterForm source="footer" theme="dark" />
          </div>
        </div>

        <div className="lg:col-span-2">
          <p className="overline mb-4">Explore</p>
          <ul className="space-y-2 text-sm text-white/75">
            <li><Link to="/wintv" className="hover:text-gold link-underline" data-testid="footer-link-wintv">WinTV</Link></li>
            <li><Link to="/earth" className="hover:text-gold link-underline" data-testid="footer-link-earth">Earth Innovation</Link></li>
            <li><Link to="/ai-council" className="hover:text-gold link-underline" data-testid="footer-link-council">AI Council</Link></li>
            <li><Link to="/world-ai" className="hover:text-gold link-underline" data-testid="footer-link-world-ai">World AI Center</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-2">
          <p className="overline mb-4">Engage</p>
          <ul className="space-y-2 text-sm text-white/75">
            <li><Link to="/blog" className="hover:text-gold link-underline">Journal</Link></li>
            <li><Link to="/contact" className="hover:text-gold link-underline">Contact</Link></li>
            <li><Link to="/members" className="hover:text-gold link-underline">Members</Link></li>
            <li><Link to="/agents" className="hover:text-gold link-underline">AI Agents</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-3">
          <p className="overline mb-4">Manifesto</p>
          <p className="text-sm text-white/75 leading-relaxed">
            Innovation in service of life. We invite scientists, healers, inventors and
            elders to build a regenerative future together.
          </p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between text-xs text-white/50">
          <p>© {new Date().getFullYear()} WinWorld Innovation. All rights reserved.</p>
          <p className="mt-2 md:mt-0">A global platform · Built for the next century.</p>
        </div>
      </div>
    </footer>
  );
}
